<template>
  <div>
    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="650px">
      <v-card>
        <v-card-title>
          <div class="d-flex">
            <div class="primary--text">
              Generar nota de crédito
            </div>
            <v-spacer />
          </div>
        </v-card-title>
        <v-card-text>
           <v-form ref="creditNoteForm" v-model="creditNoteForm.valid">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="creditNoteForm.form.folio"
                  label="Folio"
                  outlined
                  rounded
                  dense
                  hide-details
                  :rules="creditNoteForm.rules.required"/>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="creditNoteForm.form.paymentForm"
                  rounded
                  outlined
                  dense
                  hide-selected
                  hide-details
                  :items="creditNoteForm.types"
                  :rules="creditNoteForm.rules.required"
                  item-text="name"
                  item-value="value"
                  label="Forma de pago"/>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="creditNoteForm.form.invoice"
                  rounded
                  outlined
                  dense
                  hide-selected
                  hide-details
                  :items="invoices"
                  :rules="creditNoteForm.rules.required"
                  item-text="uuid"
                  item-value="uuid"
                  label="Factura relacionada"/>
              </v-col>
              <v-col cols="12">
                <v-data-table
                    :loading-text="creditNoteForm.table.title"
                    :server-items-length="creditNoteForm.table.total"
                    :loading="creditNoteForm.table.loading"
                    :headers="creditNoteForm.table.headers"
                    :items="creditNoteForm.table.data"
                    :options="creditNoteForm.table.options"
                    sort-by="product"
                    class="elevation-1"
                    fixed-header
                    hide-default-footer>
                    <template v-slot:footer>
                      <v-btn
                        tile
                        text
                        color="primary"
                        width="100%"
                        @click="onOpenProductDialog">
                        <v-icon>
                          mdi-plus
                        </v-icon>
                        Seleccionar producto
                      </v-btn>
                    </template>
                    <template v-slot:item.action="{ item }">
                      <div class="d-flex justify-end align-center">
                        <v-tooltip left>
                          <template
                            v-slot:activator="{ on }">
                            <v-btn
                              fab
                              x-small
                              depressed
                              color="primary"
                              class="mr-2"
                              v-on="on"
                              @click="editProduct(item)">
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip left>
                          <template
                            v-slot:activator="{ on }">
                            <v-btn
                              fab
                              x-small
                              depressed
                              color="error"
                              v-on="on"
                              @click="onOpenRemoveProductDialog(item)">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Eliminar</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:item.total="{ item }">
                      ${{ (item.total || 0) | toFixNumber(2) }}
                    </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            rounded
            small
            depressed
            @click="onCloseCreditNoteDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            @click="generateCreditNote">
            Generar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      @keydown.esc="productDialog=false"
      v-model="productDialog"
      max-width="400"
      persistent>
      <v-card>
        <v-card-title>
          Producto
        </v-card-title>
        <v-card-text>
          <v-form v-model="productForm.valid" ref="productForm">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="productForm.form.product"
                  :items="productForm.products"
                  label="Insumo"
                  item-text="name"
                  item-value="_id"
                  :disabled="productForm.disable"
                  hide-selected
                  hide-no-data
                  outlined
                  rounded
                  dense
                  hide-details
                  :rules="productForm.rules.required" />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model.number="productForm.form.quantity"
                  label="Cantidad"
                  outlined
                  rounded
                  dense
                  hide-details
                  :rules="productForm.rules.required"
                  type="number" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            outlined
            rounded
            small
            depressed
            @click="onCloseProductDialog">
            Cancelar
          </v-btn>
          <v-btn
            rounded
            color="primary"
            @click="addProduct">
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      @keydown.esc="removeProductDialog=false"
      v-model="removeProductDialog"
      max-width="400"
      persistent>
      <v-card>
        <v-card-title>
          Eliminar producto {{ productRemove ? productRemove.product : '' }}
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            outlined
            rounded
            small
            depressed
            @click="onCloseRemoveProductDialog">
            Cancelar
          </v-btn>
          <v-btn
            rounded
            color="primary"
            @click="removeProduct">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>

export default {
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    products: {
      type: Array,
      default: () => []
    },
    invoices: {
      type: Array,
      default: () => []
    },
    isOpenDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      creditNoteForm: {
        valid: false,
        types: [
          { value: '01', name: 'Efectivo' },
          { value: '02', name: 'Cheque nominativo' },
          { value: '03', name: 'Transferencia electrónica de fondos' },
          { value: '04', name: 'Tarjeta de crédito' },
          { value: '05', name: 'Monedero electrónico' },
          { value: '06', name: 'Dinero electrónico' },
          { value: '08', name: 'Vales de despensa' },
          { value: '12', name: 'Dación en pago' },
          { value: '13', name: 'Pago por subrogación' },
          { value: '14', name: 'Pago por consignación' },
          { value: '15', name: 'Condonación' },
          { value: '17', name: 'Compensación' },
          { value: '23', name: 'Novación' },
          { value: '24', name: 'Confusión' },
          { value: '25', name: 'Remisión de deuda' },
          { value: '26', name: 'Prescripción o caducidad' },
          { value: '27', name: 'A satisfacción del acreedor' },
          { value: '28', name: 'Tarjeta de débito' },
          { value: '29', name: 'Tarjeta de servicios' },
          { value: '30', name: 'Aplicación de anticipos' },
          { value: '31', name: 'Intermediario pagos' },
          { value: '99', name: 'Por definir' }
        ],
        table: {
          title: 'Loading products',
          loading: false,
          data: [],
          total: 0,
          headers: [
            { text: 'Insumo', value: 'product', sortable: false },
            { text: 'Cantidad', value: 'quantity', sortable: false },
            { text: 'Total', value: 'total', sortable: false },
            { text: 'Acciones', value: 'action', sortable: false }
          ],
          options: {
            itemsPerPage: 15,
            page: 1
          }
        },
        form: {
          paymentForm: null,
          invoice: null,
          folio: ''
        },
        rules: {
          required: [v => !!v || this.$t('validations.required')]
        }
      },
      productDialog: false,
      removeProductDialog: false,
      productRemove: null,
      productForm: {
        valid: false,
        products: [],
        disable: false,
        form: {
          product: null,
          quantity: 0
        },
        rules: {
          required: [v => !!v || this.$t('validations.required')]
        }
      },
      overlay: false
    }
  },
  watch: {
    isOpenDialog: async function (val) {
      this.isOpen = val
      this.productForm.products = this.products
    }
  },
  methods: {
    onCloseCreditNoteDialog () {
      this.isOpen = false
      this.$emit('close', false)
    },
    async generateCreditNote () {
      if (this.$refs.creditNoteForm.validate()) {
        if (!this.creditNoteForm.table.data.length) {
          return this.$toasted.show('Es requerido agregar productos', { duration: 3000 })
        }
        this.overlay = true
        const payload = {
          folio: this.creditNoteForm.form.folio,
          paymentForm: this.creditNoteForm.form.paymentForm,
          invoice: this.creditNoteForm.form.invoice,
          products: this.creditNoteForm.table.data
        }
        try {
          await this.$api.post(`/v1/orders/${this.order._id}/credit-notes/generate`, payload)
          this.onCloseCreditNoteDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    onCloseRemoveProductDialog () {
      this.removeProductDialog = false
      this.productRemove = null
    },
    onOpenRemoveProductDialog (item) {
      this.removeProductDialog = true
      this.productRemove = item
    },
    onCloseProductDialog () {
      this.productDialog = false
      this.productForm.form.product = null
      this.productForm.form.quantity = 0
    },
    onOpenProductDialog () {
      this.productDialog = true
    },
    addProduct () {
      const existProductInTable = this.creditNoteForm.table.data.find(x => x.id === this.productForm.form.product)
      const product = this.productForm.products.find(x => x.id === this.productForm.form.product)

      if (this.productForm.form.quantity > product.quantityConfirmed) {
        return this.$toasted.show('La cantidad de la nota no debe ser mayor a la confirmada en la orden de compra', { duration: 3000 })
      }

      if (this.productForm.form.quantity === 0) {
        return this.$toasted.show('La cantidad debe ser mayor a 0', { duration: 3000 })
      }

      this.productForm.disable = false

      if (existProductInTable) {
        this.creditNoteForm.table.loading = true
        const product = this.productForm.products.find(x => x._id === this.productForm.form.product)
        existProductInTable.quantity = this.productForm.form.quantity
        existProductInTable.total = (this.productForm.form.quantity * product.amountWithTax)
        this.onCloseProductDialog()
        this.creditNoteForm.table.loading = false
      }

      if (!existProductInTable) {
        this.creditNoteForm.table.loading = true
        const product = this.productForm.products.find(x => x._id === this.productForm.form.product)
        this.creditNoteForm.table.data.push({
          id: this.productForm.form.product,
          product: product.name,
          quantity: this.productForm.form.quantity,
          total: (product.amountWithTax * this.productForm.form.quantity)
        })
        this.creditNoteForm.table.total = this.creditNoteForm.table.data.length
        this.onCloseProductDialog()
        this.creditNoteForm.table.loading = false
      }
    },
    editProduct (item) {
      this.productForm.disable = true
      this.productForm.form.product = item.id
      this.productForm.form.quantity = item.quantity
      this.onOpenProductDialog()
    },
    removeProduct () {
      this.creditNoteForm.table.data = this.creditNoteForm.table.data.filter(x => x.id !== this.productRemove.id)
      this.onCloseRemoveProductDialog()
    }
  }
}
</script>
